import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

import { ROOT_URL } from 'constants/Config.js';

import { Link } from 'react-router-dom';
import placeholder from 'assets/images/banner-placeholder.jpg';
import iconHeart from 'assets/images/icons/icon-heart-white.svg';
import iconVerified from 'assets/images/icons/icon-verified.svg';
import iconHeartActive from 'assets/images/icons/icon-heart-active.svg';
import iconHeartActiveRed from 'assets/images/icons/icon-heart-active-red.svg';
import iconEye from 'assets/images/icons/eye-outline.svg';
import nothingFoundImage from 'assets/images/non-photo.png';

import styles from './Item.scss';
import cn from 'classnames';

import { formatNumber, pluralize } from 'utils';
import { addToFavorites, removeFromFavorites } from 'actions/favorites';
import { setPopUp } from 'actions/environment';

import ReactTooltip from 'react-tooltip';

import CollectionsDialog from 'components/Building/Main/CollectionsDialog';
import FilterLabel from 'components/Buildings/FilterLabel';
import tracker from '../../../../services/tracker';
import { withTranslation } from 'react-i18next';

class Item extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      onSmallImageLoad: null,
      onBigImageLoad: null,
      smallImageLoaded: false,
      bigImageLoaded: false
    };
  }

  componentDidMount() {
    if (this.props.item.image) {
      this.followSmallImage();
    }
    ReactTooltip.rebuild();
  }

  componentDidUpdate() {
    const { smallImageLoaded, bigImageLoaded, onBigImageLoad } = this.state;
    if (smallImageLoaded && !bigImageLoaded && !onBigImageLoad) {
      this.followBigImage();
    }
  }

  componentWillUnmount() {
    const { onSmallImageLoad, onBigImageLoad } = this.state;
    if (onSmallImageLoad) {
      const smallImg = ReactDOM.findDOMNode(this.refs.smallImg);
      smallImg.removeEventListener('load', onSmallImageLoad);
    }
    if (onBigImageLoad) {
      const bigImg = ReactDOM.findDOMNode(this.refs.bigImg);
      bigImg.removeEventListener('load', onBigImageLoad);
    }
  }

  followSmallImage() {
    const image = ReactDOM.findDOMNode(this.refs.smallImg);
    if (image.complete) {
      this.setState({ smallImageLoaded: true });
      return;
    }

    const onSmallImageLoad = () => {
      this.setState({ onSmallImageLoad: null, smallImageLoaded: true }, () => {
        image.removeEventListener('load', onSmallImageLoad);
      });
    };
    this.setState({ onSmallImageLoad }, () => {
      image.addEventListener('load', onSmallImageLoad);
    });
  }

  followBigImage() {
    const image = ReactDOM.findDOMNode(this.refs.bigImg);
    if (image.complete) {
      this.setState({ bigImageLoaded: true });
      return;
    }

    const onBigImageLoad = () => {
      this.setState({ onBigImageLoad: null, bigImageLoaded: true }, () => {
        image.removeEventListener('load', onBigImageLoad);
      });
    };
    this.setState({ onBigImageLoad }, () => {
      image.addEventListener('load', onBigImageLoad);
    });
  }

  addDefaultSrc(placeholder, event) {
    event.target.src = placeholder;
  }

  renderFlatsCount() {
    const searchFlats = !!this.props.item.flats_by_search;
    const { t } = this.props;
    const {
      status,
      count_flats: flatsCount,
      flats_by_search: flatsBySearch,
      type_id
    } = this.props.item;

    const { isTypeFilterAction } = this.props;
    const count = searchFlats && flatsBySearch ? flatsBySearch.total : flatsCount;
    const countText = type_id == 2 ?
      `${formatNumber(count)} ${pluralize(count, t('components.buildings.list.house1'), t('components.buildings.list.house2'), t('components.buildings.list.house3'))}`
      :
      `${formatNumber(count)} ${pluralize(count, t('components.buildings.list.flat1'), t('components.buildings.list.flat2'), t('components.buildings.list.flat3'))}`;

    return (
      status === 2 ?
        <p className={styles.Appartments}>
          {t('components.buildings.list.stopped')}
        </p> :
        <p className={cn(styles.Appartments, { [styles.ForYouRequest]: searchFlats })}>
          { searchFlats ? (isTypeFilterAction ? t('components.buildings.list.byPromo') : t('components.buildings.list.byQuery')) : ''}
          <b>{countText}</b>
        </p>
    );
  }

  handleAddToCollectionClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const { item } = this.props;
    const {
      id,
      title: name
    } = item;

    tracker.sendEvent('Web_Add_To_Collection', { id, name, mode: 'list' });

    this.props.setPopUp(
      <CollectionsDialog building={{ data: this.props.item }} />,
      {
        closeStyleName: 'Default',
        contentStyleName: 'Default',
        closeIcon: 'default',
        lockScroll: false
      }
    );
  }

  handleAddToFavoritesClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const { item } = this.props;
    const {
      id: buildingId,
      title: buildingName,
      favorite
    } = item;
    const userUid = localStorage.getItem('public');

    tracker.sendEvent(favorite ? 'Web_Remove_From_Favorites' : 'Web_Add_To_Favorites', {
      id: buildingId,
      name: buildingName,
      mode: 'list'
    });

    this.props[favorite ? 'removeFromFavorites' : 'addToFavorites'](
      { buildingId, userUid },
      { buildingName, data: this.props }
    );
  }

  render() {
    const { smallImageLoaded, bigImageLoaded } = this.state;
    const { className, url, item, chessUrl, isOrderFieldTypeFilter, index, orderField, t } = this.props;
    const {
      id,
      title,
      address,
      microregion,
      image,
      status,
      flats_by_search: flatsBySearch = {},
      count_flats: flatsCount,
      view_action: hasPromo,
      cost_min: costMin,
      min_area_cost: minAreaCost,
      min_square: minSquare,
      max_square: maxSquare,
      year_built,
      construction_ending,
      construction_finished,
      checkout,
      checkout2,
      military_ipoteka,
      mat_capital,
      ipoteka,
      installments,
      favorite,
      type_id,
      is_verified
    } = item;
    const searchFlats = !!this.props.item.flats_by_search;
    const { rows: flats, total: searchFlatsCount } = flatsBySearch;
    const chessUrlWithQuery = `${chessUrl}from=main`;

    return (
      <Link
        onClick={() => tracker.sendEvent('Web_Click', { id, name: title, mode: 'list' })}
        to={url}
        className={cn(styles.Item, className)}
      >
        <div className={styles.ImageContainer}>
          <div className={styles.Hover}>
            <div className={styles.HoverButtons}>
              <div
                className={styles.HoverButton}
                onClick={this.handleAddToFavoritesClick}
                data-tip={favorite
                  ? t('components.buildings.list.removeFromFavorites')
                  : t('components.buildings.list.addToFavorites')
              }
                data-for="global"
              >
                {favorite ? <img src={iconHeartActive} alt="" className={styles.Active} /> : <img src={iconHeart} alt="" />}
                {favorite
                  ? t('components.buildings.list.alreadyInFavorites')
                  : t('components.buildings.list.addTo')
                }
              </div>
              <div
                className={cn(styles.HoverButton, 'tooltip')}
                onClick={this.handleAddToCollectionClick}
                data-tip={t('components.buildings.list.addToCollection')}
                data-for="global"
              >
                <span><i></i><i></i></span>
                {t('components.buildings.list.toCollection')}
              </div>
            </div>
          </div>
          { favorite &&
            <div className={styles.InFavorites}>
              <img src={iconHeartActiveRed} alt="" />
            </div>
          }
          {image
            ? [
              smallImageLoaded ? <img key="bigImg" ref="bigImg" alt="house" onError={this.addDefaultSrc.bind(this, placeholder)} src={`${ROOT_URL}/image?id=${image.id}&size=medium`} className={styles.BigImage} /> : null,
              <img key="smallImg" ref="smallImg" alt="house" onError={this.addDefaultSrc.bind(this, placeholder)} src={`${ROOT_URL}/image?id=${image.id}&size=small`} className={cn(styles.SmallImage, { [styles.SmallImageHide]: bigImageLoaded })} />
            ]
            : <img src={nothingFoundImage} style={{ maxWidth: '100%' }} />
          }
        </div>
        <div className={styles.Main}>
          <div className={styles.Inner}>
            <div className={styles.AddressBlock}>
              <div className={styles.Title}>
                <span>{title}</span>
                <div className={styles.Status}>
                  {is_verified && (
                    <img
                      className={styles.Verified}
                      alt={t('components.buildings.list.verified')}
                      title={t('components.buildings.list.verified')}
                      src={iconVerified}
                    />
                  )}
                  {hasPromo ? <span className={styles.PromoLabel}>{t('components.buildings.list.promo')}</span> : null}
                  <span
                    className={
                    cn(
                      styles.StatusTitle,
                      {
                        [styles.StatusTitleFinished]: !!construction_finished && status !== 3,
                        [styles.StatusTitleAlmostFinished]: status == 3
                      }
                      )
                  }
                  >
                    {status == 3
                      ? t('components.buildings.list.almostFinished')
                      : construction_finished
                        ? t('components.buildings.list.finished')
                        : `${year_built !== 0 ? ((construction_ending ? `${construction_ending} / ` : '') + year_built) : t('components.buildings.list.inProgress')}`
                    }
                  </span>
                </div>
              </div>
              <div className={styles.WrapperAddress}>
                <div className={styles.Address}>
                  <span className={styles.TextAddress}>{`${microregion}, ${address}`}</span>
                </div>
              </div>
            </div>
            {orderField === 'visit_day' && <p className={styles.popularLaberl}><img src={iconEye} />{item.visit_day}</p>}
            {orderField === 'visit_week' && <p className={styles.popularLaberl}><img src={iconEye} />{item.visit_week}</p>}
            {orderField === 'visit_month' && <p className={styles.popularLaberl}><img src={iconEye} />{item.visit_month}</p>}
            <div className={styles.InfoBlock}>
              <div className={styles.Block}>
                {checkout2 ? <p className={styles.BlockItem}>{checkout2 === 'Предварительный договор' ? t('components.buildings.list.beforeAgr') : checkout2}</p> : null}
                {checkout ? <p className={styles.BlockItem}>{checkout}</p> : null}
              </div>
              <div className={styles.Block}>
                {military_ipoteka ? <p className={styles.BlockItem}>{t('components.buildings.list.military_ipoteka')}</p> : null}
                {mat_capital ? <p className={styles.BlockItem}>{t('components.buildings.list.mat_capital')}</p> : null}
                {ipoteka ? <p className={styles.BlockItem}>{t('components.buildings.list.ipoteka')}</p> : null}
                {installments ? <p className={styles.BlockItem}>{t('components.buildings.list.installments')}</p> : null}
              </div>
            </div>
          </div>

        </div>
        {flatsCount ? (
          <div className={cn(styles.Price, { [styles.Stopped]: status === 2 })}>
            {(status === 2) ? (
              <div className={styles.Message}>
                <span dangerouslySetInnerHTML={{ __html: t('components.buildings.list.paused') }} />
              </div>
              ) : (
                <div>
                  { this.renderFlatsCount() }
                  <div className={styles.PriceBlock}>
                    <p className={styles.StartPrice}>
                      {t('components.buildings.list.costMin', {
                        costMin: formatNumber(searchFlats ? Math.min.apply(null, flats.map(f => f.cost)) : costMin)
                      })}
                    </p>
                    <p className={styles.PricePerMeter}>
                      {t('components.buildings.list.minAreaCost', {
                        minAreaCost: formatNumber(searchFlats ? Math.min.apply(null, flats.map(f => f.price)) : minAreaCost)
                      })}
                    </p>
                  </div>
                  {((searchFlats ? searchFlatsCount : flatsCount) === 1)
                      ? (
                        <p className={styles.Area}>
                          {t('components.buildings.list.square', {
                            square: formatNumber(searchFlats ? Math.min.apply(null, flats.map(f => f.area)) : minSquare)
                          })}
                        </p>
                    ) : (
                      <p className={styles.Area}>
                        {t('components.buildings.list.square12', {
                          square1: formatNumber(searchFlats ? Math.min.apply(null, flats.map(f => f.area)) : minSquare),
                          square2: formatNumber(searchFlats ? Math.max.apply(null, flats.map(f => f.area)) : maxSquare)
                        })}
                      </p>
                    )
                  }
                  <Link to={chessUrlWithQuery} className={styles.ChessLink}>
                    {t('components.buildings.list.chess')} <i></i>
                  </Link>
                </div>
              )}
          </div>
          )
          : <div className={cn(styles.Price, styles.Empty)}>
            <div className={styles.Message}>
              {status === 2
                ? t('components.buildings.list.stopped2')
                : <span dangerouslySetInnerHTML={{ __html: type_id == 2 ? t('components.buildings.list.soldHouses') : t('components.buildings.list.soldFlats') }} />
              }
            </div>
          </div>
          }
        <FilterLabel isPopularList={isOrderFieldTypeFilter} index={index} isBlackList={item.black_list} isNew={item.new} isNedvex={item.nedvex} />
      </Link>
    );
  }
}

export default withTranslation()(connect((state) => ({
  isOrderFieldTypeFilter: state.search.isOrderFieldTypeFilter,
  orderField: state.search.request.orderField
}), { setPopUp, addToFavorites, removeFromFavorites })(Item));



// WEBPACK FOOTER //
// ./src/components/Buildings/List/Item/Item.js